<template>
  <div v-if="cottageRecommended">
    <TText size="lg" variant="semibold" classes="text-center pb-5 pt-2">
      {{ t('views.cottage.recommended.title') }}
    </TText>

    <div class="grid gap-5 grid-cols-1 md:grid-cols-2 max-w-2xl mx-auto">
      <template v-for="item in cottageRecommended" :key="item">
        <a :href="`${item.url}`" class="flex items-center" target="_parent">
          <span class="relative inline-block">
            <span class="rounded-md overflow-hidden block h-20 w-20">
              <TLazyimg
                :src="item.image.src"
                alt=""
                classes-img="object-cover w-full h-full t-card__img"
                classes="rounded-full absolute inset-0 h-full w-full"
              />
            </span>
          </span>

          <div class="ml-4 overflow-hidden grow">
            <TText size="sm" variant="semibold" clamp="clamp1" classes="mb-0">
              {{ item.villagename }}, {{ item.provincename }}
            </TText>
            <TText
              color="text-gray-900"
              size="sm"
              clamp="clamp1"
              classes="mb-0"
            >
              {{ t('views.cottage.recommended.maxcapacity', item.maxcapacity) }}
            </TText>
            <div class="flex">
              <TStars
                :comments="item.rating.votes"
                :stars="item.rating.rating"
                :compact="true"
              />
            </div>
            <TText size="sm" variant="semibold" clamp="clamp1" classes="mb-0">
              <template v-if="item.pricesummary?.price">
                {{
                  item.pricesummary.type === 'from'
                    ? t('views.cottage.from')
                    : ''
                }}
                {{ item.pricesummary?.price }} €
              </template>
              <template v-else
                >{{ item.priceaverage }} €
                {{ t('views.cottage.priceAverageText') }}</template
              >
            </TText>
          </div>
        </a>
      </template>
    </div>
  </div>
</template>

<script setup lang="ts">
import fetchCottagesRecommended from '~~/modules/api/rurality/v2/cottages/recommended'
import { useToCottageContactDealRecommended } from '../composables/transformers/useToCottageContactDealRecommended'
import type { CottageContactDealRecommended } from '../entities/CottageContactDealRecommended'

let cottageRecommended: CottageContactDealRecommended

const props = defineProps({
  id: { type: String, required: true },
  startDate: { type: String, required: false },
  endDate: { type: String, required: false },
  capacity: { type: String, required: false },
})

const params = {
  id: props.id,
  startDate: props.startDate,
  endDate: props.endDate,
  capacity: props.capacity,
}

const data = await fetchCottagesRecommended(params)

if (data.success) {
  cottageRecommended =
    useToCottageContactDealRecommended().fromRuralityCottageRecommended(
      data.success?.data,
    )
}
</script>
